function updateDrawerAndModalPosition() {
  const scrollTop = window.scrollY || document.documentElement.scrollTop;
  const isAtTop = scrollTop === 0;
  const isMobile = window.innerWidth <= 699;

  const baseTop = isMobile ? 96 : 105;
  const finalTop = isAtTop ? baseTop : baseTop - 42;

  const styleId = 'dynamic-top-style';
  let styleTag = document.getElementById(styleId);

  const css = `
    #sidebar-menu::part(base) {
      top: ${finalTop}px !important;
    }

    :where(#sidebar-menu)::part(overlay) {
      top: ${finalTop}px !important;
    }
  `;

  if (!styleTag) {
    styleTag = document.createElement('style');
    styleTag.id = styleId;
    document.head.appendChild(styleTag);
  }

  styleTag.textContent = css;
}

// Run on load
window.addEventListener('load', updateDrawerAndModalPosition);

// Run on scroll
window.addEventListener('scroll', updateDrawerAndModalPosition);

// Run on resize
window.addEventListener('resize', updateDrawerAndModalPosition);
